import Cookie from "js-cookie";

import api from "../../utils/helpers/api";
import * as actionTypes from "../../utils/constants/actionTypes";
import * as constants from "../../utils/constants/constant";

import { getUserAffiliationInfo } from "../../features/dashboard/actions";
//// fet api

const getGeneralInfo = (params) => {
  return api({
    method: "get",
    url: "/customer-engagement/aff/get-general-info",
  });
};

const getListBank = (params) => {
  return api({
    method: "get",
    url: "/customer-engagement/aff/get-bank-list",
  });
};

export const actionLogin = (data) => {
  Cookie.remove(constants.EXPIRED);
  Cookie.remove(constants.JWT);
  Cookie.remove(constants.USER_ROLES);
  // if (users.rememberMe) {
  //   Cookie.set(Constants.LAST_LOGIN, users.username);
  // } else {
  //   Cookie.remove(Constants.LAST_LOGIN);
  // }
  return api({
    method: "post",
    url: "/api/v1/oauth/token",
    noAuth: true,
    data: data,
  });
};

// action
export const actionGetProfile = () => async (dispatch) => {
  try {
    dispatch({
      type: actionTypes.FETCHING_PROFILE,
    });
    const { data } = await getUserAffiliationInfo();
    if (data.code === 200) {
      dispatch({
        type: actionTypes.FETCHING_PROFILE_SUCCESS,
        payload: data.data,
      });
    } else {
      dispatch({
        type: actionTypes.FETCHING_PROFILE_ERROR,
        payload: data.data,
      });
    }
  } catch (error) {
    dispatch({
      type: actionTypes.FETCHING_PROFILE_ERROR,
    });
  }
};

export const actionGeneralInfo = () => async (dispatch) => {
  try {
    const { data } = await getGeneralInfo();
    if (data.code === 200) {
      dispatch({
        type: actionTypes.FETCHING_GENERAL_INFO,
        payload: data.data,
      });
    }
  } catch (error) {}
};

export const actionGetListBank = () => async (dispatch) => {
  try {
    const { data } = await getListBank();
    if (data.code === 200) {
      dispatch({
        type: actionTypes.FETCHING_LIST_BANK,
        payload: data?.data?.items,
      });
    }
  } catch (error) {}
};

export const actionShowLoading = () => ({
  type: actionTypes.SHOW_LOADING,
});

export const actionHideLoading = () => ({
  type: actionTypes.HIDE_LOADING,
});

export const actionChangeLang = (locale) => ({
  type: actionTypes.CHANGE_LANG,
  payload: locale,
});

export const actionLogout = () => {
  Cookie.remove(constants.JWT);
  Cookie.remove(constants.EXPIRED);
  Cookie.remove(constants.Roles.ROLE_USER);
  return {
    type: actionTypes.SIGN_OUT,
  };
};
